import { createContext, useContext } from "react";

interface LoopContextValue {
  loopCount: number;
  isUnlocked: boolean;
}

export const LoopContext = createContext<LoopContextValue>({
  loopCount: 0,
  isUnlocked: false,
});

export function useLoop() {
  return useContext(LoopContext);
}
